import { format } from 'date-fns';
import { defaultTimeFormat } from './constants';
import getLocale from './getLocale';
import parseDate from './parseDate';

const formatTime = (time, dateFormat = defaultTimeFormat) => {
  const parsedDateTime = parseDate(time);

  return parsedDateTime ? format(parsedDateTime, dateFormat, { locale: getLocale() }) : null;
};

export default formatTime;
